import { render } from "./UnassignedVisits.vue?vue&type=template&id=5a1c1eed&ts=true"
import script from "./UnassignedVisits.ts?vue&type=script&lang=ts&external"
export * from "./UnassignedVisits.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__